import { LegalPage } from "@/components/legal/LegalPage";

export default function Privacy() {
  return <LegalPage doc="privacy" />;
}
